import React from 'react'
import './CheckMark.scss'

interface CheckMarkProps {
  stroke: string
}

export const CheckMark: React.FC<CheckMarkProps> = ({ stroke }) => {
  return (
    <div className='checkmark-wrapper p-2'>
      <div className='checkmark-circle' style={{ '--checkmark-stroke': stroke } as React.CSSProperties}>
        <i className='bi bi-check-lg checkmark-icon' />
      </div>
    </div>
  )
}
